import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';

export class FailureCause implements ViewModel {
  friendlyTypeNameSingular: string = 'Failure Cause';
  apiRoute: string = CONFIG.apiRoutes.failureCause;

  selected: boolean;
  id: string;
  code: string;
  description: string;
  isSaved: boolean = false;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.code = data.code;
    this.description = data.description;
    this.isSaved = data.isSaved;
  }
}
